
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/404",
      function () {
        return require("private-next-pages/[lng]/404.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/404"])
      });
    }
  